import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">爆款瓜文</h2>
          <p className="text-foreground-500 text-sm md:text-base">深度报道 · 独家视角 · 每日更新</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.map((card, i) => (
            <article
              key={card.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="relative overflow-hidden">
                <img
                  src={card.image}
                  alt={`${card.title} - 五一黑料网独家报道`}
                  className="w-full aspect-[16/10] object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                  {card.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-4">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.date}</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}